export default function changeUrl(url) {
  let passport_test = "https://passport-test.eiceducation.com.cn/api/v1/";
  let passport_pro = "https://passport.eiceducation.com.cn/api/v1/";
  let mock_test = "https://kp-ipracticeapi-test.eiceducation.com.cn/api";
  let mock_pro = "https://kp-ipracticeapi.eiceducation.com.cn/api";
  let testopia_test = "https://testopia-api-test.eiceducation.com.cn/api";
  let testopia_pro = "https://testopia-api.eiceducation.com.cn/api";

  if (window.location.origin == "https://online.eickaopei.com") {
    //正式站
    if (url.indexOf("https://schoolapi-test.eiceducation.com.cn") > -1) {
      url = url.replace(
        "https://schoolapi-test.eiceducation.com.cn",
        "https://schoolapi.eiceducation.com.cn"
      );
    }
    if (url.indexOf(passport_test) > -1) {
      url = url.replace(passport_test, passport_pro);
    }
    if (url.indexOf(mock_test) > -1) {
      url = url.replace(mock_test, mock_pro);
    }
    if (url.indexOf(testopia_test) > -1) {
      url = url.replace(testopia_test, testopia_pro);
    }
  } else {
    //测试站
    if (url.indexOf("https://schoolapi.eiceducation.com.cn") > -1) {
      url = url.replace(
        "https://schoolapi.eiceducation.com.cn",
        "https://schoolapi-test.eiceducation.com.cn"
      );
    }
    if (url.indexOf(passport_pro) > -1) {
      url = url.replace(passport_pro, passport_test);
    }
    if (url.indexOf(mock_pro) > -1) {
      url = url.replace(mock_pro, mock_test);
    }
    if (url.indexOf(testopia_pro) > -1) {
      url = url.replace(testopia_pro, testopia_test);
    }
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/api/changeUrl.js